import { render, staticRenderFns } from "./OldRatingCustomAlert.vue?vue&type=template&id=27189c1e"
import script from "./OldRatingCustomAlert.vue?vue&type=script&lang=ts"
export * from "./OldRatingCustomAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports